<template>
    <ul class="sample">
        <li>
            <i>{{ emoji.level.image }}</i>
            <span>{{ emoji.level.desc}}:</span>
            <span style="cursor:pointer" @click="changeStage" :title="isPlaying ? '当前难度:' + getNowStage() : '换个难度'">{{levelEmoji}}</span>
        </li>
        <li>
            <i>{{ emoji.playing.image }}</i>
            <span>状态:</span>
            <span v-if="isPlaying" title="玩耍中...">{{ emoji.playing.desc}}</span>
            <span v-else title="空闲...">{{ emoji.noPlay.desc}}</span>   
        </li>
        <li><i>{{ emoji.bomb.image }}</i><span>{{ emoji.bomb.desc }}:</span><span>{{ bombCount }}</span></li>
        <li><i>{{ emoji.flag.image }}</i><span>{{ emoji.flag.desc }}:</span><span>{{ flagCount }}</span></li>
        <timer />
    </ul>
</template>
<script>
import { getLevel } from '../../utils/play'
import { emoji } from '../../const'
import timer from './timer'

export default {
    name: 'Sample',
    data () {
        return {
            emoji
        }
    },
    computed: {
        level () {
            return this.$store.state.level
        },
        isPlaying () {
        return this.$store.state.isPlaying
        },
        levelEmoji () {
            return emoji.stage[this.level].image
        },
        bombCount () {
            return this.$store.state.bombCount
        },
        flagCount () {
            return this.$store.state.flagCount.length
        }
    },
    methods: {
        changeStage () {
            if( this.isPlaying ) return
            this.$store.dispatch('changeStage', this.level + 1)
        },
        getNowStage() {
            return getLevel(this.level)
        }
    },
    components: {
        timer
    }
}
</script>
<style lang="scss">
.sample {
    flex: 1;
    
    li {
        display: flex;
        margin: 20px 0;
        font-size: 1.2rem;


        i {
            margin-right:10px;
            justify-content: center;
            align-items: center;
            display: inline-flex;
            text-align: center;
            font-style:normal;
            width:35px;
        }

        span {
            display: inline-flex;
            align-items: center;
            flex: 1;

            &:last-child {
                flex:none;
                justify-content: center;
                color: rgb(219, 115, 46);
                // font-size: 2rem;
            }
        }
        
    }
}  
</style>